import React from 'react';
import './LocationDisabledBadge.css';

function LocationDisabledBadge({ className = '' }) {
  return (
    <span className={['location-disabled-badge', className].filter(Boolean).join(' ')}>
      Disabled
    </span>
  );
}

export default LocationDisabledBadge;
